import React, { memo } from 'react'
import { Col, Row } from 'react-bootstrap'

import CustomerDefaultAddress from '../CustomerAddresses/CustomerDefaultAddress'

function CustomerPersonalInformation(props) {
    const { addressess, customer, countries = [], refreshAddress } = props
    return (
        <React.Fragment>
            <Row className="pad-20-R">
                <Col xs={12} md={6} lg={6}>
                    < div className="app-card customer-address" >
                        <div className="border st-default-rounded-block pad-20"
                            style={{
                                minHeight: 295, display: "flex", alignItems: "center"
                            }}>
                            <Row>
                                <Col xs={12} md={12} lg={12} className="p-2 border-bottom st-border-light">
                                    <Row>
                                        <Col xs={12} md={12} lg={5}>
                                            <span className="st-fs-13 st-fw-600">Last Logged In:</span>
                                        </Col>
                                        <Col xs={12} md={12} lg={7}>
                                            <p className="app-heading text-capitalize st-fw-600 st-fs-15">{customer.last_login}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} md={12} lg={12} className="p-2 border-bottom st-border-light">
                                    <Row>
                                        <Col xs={12} md={12} lg={5}>
                                            <span className="st-fs-13 st-fw-600">Status:</span>
                                        </Col>
                                        <Col xs={12} md={12} lg={7}>
                                            <p className="app-heading text-capitalize text-left st-fw-600 st-fs-15">
                                                {customer.customer_status === 1 ? 'active' : 'inactive'}
                                            </p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} md={12} lg={12} className="p-2 border-bottom st-border-light">
                                    <Row>
                                        <Col xs={12} md={12} lg={5}>
                                            <span className="st-fs-13 st-fw-600">Confirmation Mail:</span>
                                        </Col>
                                        <Col xs={12} md={12} lg={7}>
                                            <p className="app-heading st-fw-600 st-fs-15">{"Confirmation Not required"}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} md={12} lg={12} className="p-2 border-bottom st-border-light">
                                    <Row>
                                        <Col xs={12} md={12} lg={5}>
                                            <span className="st-fs-13 st-fw-600">Account Created:</span>

                                        </Col>
                                        <Col xs={12} md={12} lg={7}>
                                            <p className="app-heading st-fw-600 st-fs-15">{customer.date_created}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} md={12} lg={12} className="p-2 border-bottom st-border-light">
                                    <Row>
                                        <Col xs={12} md={12} lg={5}>
                                            <span className="st-fs-13 st-fw-600">Account Created In:</span>
                                        </Col>
                                        <Col xs={12} md={12} lg={7}>
                                            <p className="app-heading st-fw-600 st-fs-15">{"Default Store View"}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} md={12} lg={12} className="p-2">
                                    <Row>
                                        <Col xs={12} md={12} lg={5}>
                                            <span className="st-fs-13 st-fw-600">Customer Group:</span>
                                        </Col>
                                        <Col xs={12} md={12} lg={7}>
                                            <p className="app-heading st-fw-600 st-fs-15">
                                                {customer.customer_group || customer.customer_group_name || customer.group_name}
                                            </p>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div >
                </Col>
                <Col xs={12} md={6} lg={6}>
                    <CustomerDefaultAddress address={addressess.filter(e => e.is_default)[0]}
                        countries={countries}
                        refreshAddress={refreshAddress}
                    />
                </Col>
            </Row >

        </React.Fragment >
    )
}

export default memo(CustomerPersonalInformation)